// extracted by mini-css-extract-plugin
module.exports = {"order-skeletons":"GIZuvvIEScS8wMXIHH2AR","order-item":"_1sUxYrM4dxNbWmwMV_NnT0","skeletons":"_3yCdKWWZ8UqV9ftRvK4llK","loading":"_1LoUmkNA20-2hW0dCdZ3w6"};